import { AxiosRequestConfig, AxiosResponse } from 'axios';
import _ from 'lodash';
import { JagoAxiosInstance } from './JagoAxiosInstance';
import { IGatewaysArtifactsRequestParamsDTO, IGatewaysDeploymentsRequestParamsDTO, IGatewaysRequestParamsDTO } from './model/output/RequestParamsDTOs';
import { PaginationQueryParamsDTO, PaginationRestDTO } from '@bottega52/commons-pagination';
import IGatewayInDTO from './model/input/IGatewayInDTO';
import { IGatewayArtifactInDTO } from './model/input/IGatewayArtifactInDTO';
import { IGatewayDeploymentInDTO } from './model/input/IGatewayDeploymentInDTO';
import { IGatewayDeploymentOutDTO } from './model/output/IGatewayDeploymentOutDTO';
import { IGatewayDeploymentStatusInDTO } from './model/input/IGatewayDeploymentStatusInDTO';
import IGatewayLogEntryDTO from './model/input/IGatewayLogEntryDTO';

export interface IGatewayLogsRequestParamsDTO {
  limit?: number;
  startNs?: string;
  endNs?: string;
  /** When not false, backend should exclude updater lines (sent as query string `true` / `false`). */
  excludeUpdater?: boolean;
}

export function fetchGateways(params?: IGatewaysRequestParamsDTO): Promise<AxiosResponse<PaginationRestDTO<IGatewayInDTO>>> {
  const config: AxiosRequestConfig = {
    params,
  };
  return JagoAxiosInstance.get('api/v2/support/gateways', config);
}

export function fetchGatewaysArtifats(params?: IGatewaysArtifactsRequestParamsDTO): Promise<AxiosResponse<PaginationRestDTO<IGatewayArtifactInDTO>>> {
  const config: AxiosRequestConfig = {
    params,
  };
  return JagoAxiosInstance.get('api/v2/support/gateways/artifacts', config);
}

export function fetchGatewaysDeployments(params?: IGatewaysDeploymentsRequestParamsDTO): Promise<AxiosResponse<PaginationRestDTO<IGatewayDeploymentInDTO>>> {
  const config: AxiosRequestConfig = {
    params,
  };
  return JagoAxiosInstance.get('api/v2/support/gateways/deployments', config);
}

export function createGatewaysDeployment(deployment: IGatewayDeploymentOutDTO): Promise<AxiosResponse<IGatewayDeploymentInDTO>> {
  return JagoAxiosInstance.post('api/v2/support/gateways/deployments', deployment);
}

export function fetchDeploymentDetails(deploymentId: number, params: PaginationQueryParamsDTO): Promise<AxiosResponse<PaginationRestDTO<IGatewayDeploymentStatusInDTO>>> {
  const config: AxiosRequestConfig = {
    params,
  };
  return JagoAxiosInstance.get(`api/v2/support/gateways/deployments/${deploymentId}`, config);
}

export function fetchGatewayDeployments(gatewayId: number, params?: IGatewaysDeploymentsRequestParamsDTO): Promise<AxiosResponse<PaginationRestDTO<IGatewayDeploymentStatusInDTO>>> {
  const config: AxiosRequestConfig = {
    params: { gatewayId, ...params },
  };
  return JagoAxiosInstance.get(`api/v2/support/gateways/deployments/details`, config);
}

export function fetchGatewayLogsFromJago(gatewayId: number, params: IGatewayLogsRequestParamsDTO): Promise<AxiosResponse<{ logs: IGatewayLogEntryDTO[] }>> {
  const config: AxiosRequestConfig = {
    params: _.pickBy(
      {
        limit: params.limit,
        startNs: params.startNs,
        endNs: params.endNs,
        excludeUpdater: params.excludeUpdater === false ? 'false' : 'true',
      },
      (v) => v !== undefined && v !== ''
    ),
  };
  return JagoAxiosInstance.get(`api/v2/support/gateways/${gatewayId}/grafana/logs`, config);
}